import React from 'react';
import { Empty } from 'antd';

import './customEmpty.scss';

export enum CustomEmptyType {
    Report = 'report',
    VideoDevices = 'video_devices',
    Videos = 'videos',
    DvrHealthReport = 'dvr_health_report',
    VideoSearch = 'video_search',
    Widget = 'widget',
}

const DEFAULT_TITLE = 'No data'
const getTitleContent = (type: 
    `${CustomEmptyType.Report}` | 
    `${CustomEmptyType.VideoDevices}` | 
    `${CustomEmptyType.Videos}` | 
    `${CustomEmptyType.VideoSearch}` | 
    `${CustomEmptyType.DvrHealthReport}` | 
    `${CustomEmptyType.Widget}`
): string => {
    if (!type) {
        return DEFAULT_TITLE;
    } else {
        switch (type) {
            case CustomEmptyType.Report:
                return 'Enter your search requirements to generate a report';
            case CustomEmptyType.VideoDevices:
                return 'No video devices found for the asset';
            case CustomEmptyType.Videos:
                return 'Cannot load videos: device may be offline';
            case CustomEmptyType.DvrHealthReport:
                return 'Device is healthy';
            case CustomEmptyType.VideoSearch:
                return 'Enter your requirements to search videos for an asset';
            case CustomEmptyType.Widget:
                return DEFAULT_TITLE;
            default:
                return DEFAULT_TITLE;
        }
    }

}
const getDescriptionContent = (type: 
    `${CustomEmptyType.Report}` | 
    `${CustomEmptyType.VideoDevices}` | 
    `${CustomEmptyType.Videos}` | 
    `${CustomEmptyType.VideoSearch}` | 
    `${CustomEmptyType.DvrHealthReport}` | 
    `${CustomEmptyType.Widget}`
): string | null => {
    if (!type) {
        return null;
    } else {
        switch (type) {
            case CustomEmptyType.Report:
                return 'Use the filter bar on the left to select Asset(s)/Driver(s), the divison and the date (optional) of the data you would like to display';
            case CustomEmptyType.VideoDevices:
                return null;
            case CustomEmptyType.Videos:
                return null;
            case CustomEmptyType.DvrHealthReport:
                return null;
            case CustomEmptyType.VideoSearch:
                return null;
            case CustomEmptyType.Widget:
                return null;
            default:
                return DEFAULT_TITLE;
        }
    }
}

interface CustomEmptyProps {
    type: 
        `${CustomEmptyType.Report}` | 
        `${CustomEmptyType.VideoDevices}` | 
        `${CustomEmptyType.Videos}` | 
        `${CustomEmptyType.VideoSearch}` |
        `${CustomEmptyType.DvrHealthReport}` |
        `${CustomEmptyType.Widget}`;
    showIcon?: boolean;
}

const CustomEmpty: React.FC<CustomEmptyProps> = ({
    type = CustomEmptyType.Report,
    showIcon = true,
}) => {
    if (type === CustomEmptyType.Widget) {
        return (
            <div style={{
                fontSize: '32px',
                textAlign: 'center',
                color: 'var(--cool-gray-60)',
            }}>
                0
            </div>
        );
    } else {
        const description = getDescriptionContent(type);
        return (
            <Empty
                description={(
                    <>
                        <div className='title'>{getTitleContent(type)}</div>
                        {description && (<div className='description'>{description}</div>)}
                    </>
                )}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                imageStyle={{ display: showIcon ? 'block' : 'none' }} 
            />
        );
    }

}

export default CustomEmpty;